import { action, computed, observable } from 'mobx'
import { SHRSortAttributesList } from '@components/UI-Components/QuantityType/constants/QuantityType'

export interface sortOptions {
  name: string
  value: string
  isSelected: boolean
  sortOrder: string
  quantityType: string
}
export class SortStore {
  @observable isSortLoading = false
  @observable validAttributes = false
  @observable sortAttributes = SHRSortAttributesList
  @observable appliedSortOptions: sortOptions = {
    name: '',
    value: '',
    isSelected: false,
    sortOrder: '',
    quantityType: ''
  }

  @computed get isDefaultSelected() {
    return this.appliedSortOptions.isSelected
  }

  @action
  setAppliedSortOptions = (appliedSortOptions: sortOptions) => {
    this.appliedSortOptions = appliedSortOptions
  }

  @action
  clearAppliedSortOptions = () => {
    this.appliedSortOptions = {
      name: '',
      value: '',
      isSelected: false,
      sortOrder: '',
      quantityType: ''
    }
  }

  @action sortAgain = () => {
    this.setAppliedSortOptions(this.appliedSortOptions)
  }
  @action
  setLoading = (isSortLoading: boolean) => {
    this.isSortLoading = isSortLoading
  }

  @action
  resetSortData = () => {
    this.isSortLoading = false
    this.appliedSortOptions = {
      name: '',
      value: '',
      isSelected: false,
      sortOrder: '',
      quantityType: ''
    }
  }
}
